webpackJsonp([179519099177887],{

/***/ 571:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"楽しいだけで十分です"}},"markdownRemark":{"html":"<p><a href=\"https://qiita.com/mysticatea/items/cc3f648e11368799e66c\">ESLint のカスタムルールを作ろう! (その1) - Qiita</a> を見ながら写経してみました。合わせてメモも取っていたので、それをぺたり。</p>\n<hr>\n<h3>Ruleとは</h3>\n<ul>\n<li>1つ以上のメソッドを持つオブジェクト</li>\n<li>メソッド名は、抽象構文木(AST)のノードの種類になる</li>\n<li>コードに該当するメソッド名のノードが現れたら、メソッドが呼び出される</li>\n</ul>\n<h3>抽象構文木(AST)とは</h3>\n<ul>\n<li>文字列データであるソースコードを解析して、オブジェクトにしたもの</li>\n<li>ESLint は事前にソースコードを解析してオブジェクト(JSON)にしてから、それを各ルールに渡す</li>\n<li>JavaScriptの抽象構文木(AST)の仕様は、<a href=\"https://github.com/estree/estree\">estree/estree: The ESTree Spec</a>  で管理</li>\n<li>実際のコードのASTを確認したい時は、<a href=\"http://astexplorer.net/#/VeRiaJxlcX\">AST explorer</a>を使うといい</li>\n</ul>","frontmatter":{"title":"ESLintのカスタムルールの作り方を学ぶ"}}},"pathContext":{"slug":"/20180808/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---20180808-0b5e89ecb0ede124f102.js